import { render, staticRenderFns } from "./ISAChangePattern.vue?vue&type=template&id=4560148e&scoped=true&"
import script from "./ISAChangePattern.vue?vue&type=script&lang=js&"
export * from "./ISAChangePattern.vue?vue&type=script&lang=js&"
import style0 from "./ISAChangePattern.vue?vue&type=style&index=0&id=4560148e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4560148e",
  null
  
)

export default component.exports